<template>
  <div>
    <v-app>
      <v-app-bar ref="navbar" app color="primary" dark elevation="2">
        <!-- display: block -->
        <v-btn icon @click="onStart" class="ml-12 pl-4">
          <v-img contain max-height="40px" max-width="72px" src="./assets/easyai-logo.png"></v-img>
        </v-btn>

        <v-spacer></v-spacer>
        <!-- TODO to be used if several pages are in use
        <v-btn text color="secondary" @click="onStart">Start</v-btn>
        -->
        <v-btn text color="white--text" @click="onServices">Tjänster</v-btn>
        <v-btn text color="white--text" @click="onAbout">Om Oss</v-btn>
        <v-btn text color="white--text" class="mr-12" @click="onContact">Kontakt</v-btn>
      </v-app-bar>

      <v-img src="./assets/background-2.webp">
        <v-row class="fill-height mt-4" align="center" justify="center">
          <v-col class="text-left ml-8">
            <div class="text-h1 font-weight-bold white--text">Easy AI</div>
            <div class="text-h4 white--text">
              Er vägledning mot framgångsrik implementering av AI.
            </div>
            <div class="text-h4 white--text">Från utbildning till skräddarsydda AI program.</div>
            <!--
            <div class="text-body-1 white--text">
              Eller har du kanske redan använd teknologien och insett att teknologien skulle kunde
              ändra din verdag signifikant.
            </div>
            <div class="text-body-1 white--text">
              I båda fallen hjälpar vi dig accelerera värdeskapande med AI i din verksamhet.
            </div>
            <div class="text-body-1 white--text">
              Läs mer om oss och upptäck våra tjänster nedan.
            </div>
            -->
          </v-col>
        </v-row>
      </v-img>

      <!-- Services -->
      <div ref="services" class="ma-12">
        <div class="text-h4 text-center font-weight-bold primary--text">Våra Tjänster</div>
        <v-row>
          <v-col><education-service></education-service></v-col>
          <v-col><bespoke-service></bespoke-service></v-col>
        </v-row>
      </div>

      <!-- About -->
      <div ref="about" class="ma-12 mt-16">
        <!-- <div class="text-h4 text-center font-weight-bold primary--text">Om Oss</div> -->
        <about-details></about-details>
      </div>

      <!-- Contact -->
      <div ref="contact" class="ma-12">
        <div class="text-h4 text-center font-weight-bold primary--text">Kontakta Oss</div>
        <v-card class="my-8">
          <v-row>
            <!-- display: block -->
            <v-col cols="4">
              <contact-details></contact-details>
            </v-col>
            <!-- display: block -->
            <v-col cols="8"><contact-form></contact-form></v-col>
          </v-row>
        </v-card>
      </div>

      <!-- Router for future use -->
      <v-main>
        <router-view />
      </v-main>

      <v-btn v-if="isScrolled" fab dark fixed bottom right color="secondary" @click="onStart">
        <v-icon>mdi-arrow-up-thick</v-icon>
      </v-btn>

      <!-- display: block -->
      <v-footer app color="primary" dark absolute class="py-4">
        <v-row align="center" class="mx-12">
          <v-col cols="2">
            <div class="text-left">Easy AI</div>
          </v-col>
          <v-col cols="8">
            <div class="text-center">
              <span><v-icon small>mdi-copyright</v-icon> 2024 Cervum AB</span>
            </div>
          </v-col>
          <v-col cols="2">
            <v-list color="primary">
              <v-list-item class="justify-end" @click="onServices">Tjänster</v-list-item>
              <v-list-item class="justify-end" @click="onAbout">Om Oss</v-list-item>
              <v-list-item class="justify-end" @click="onAbout">Kontakt</v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import BespokeService from './components/BespokeService.vue'
import EducationService from './components/EducationService.vue'
import ContactDetails from './components/ContactDetails.vue'
import ContactForm from './components/ContactForm.vue'
// import AboutText from './components/AboutText.vue'
// import AboutImage from './components/AboutImage.vue'
import AboutDetails from './components/AboutDetails.vue'

export default {
  components: {
    EducationService,
    BespokeService,
    ContactDetails,
    ContactForm,
    /* AboutText, AboutImage */ AboutDetails
  },
  data: () => ({
    isScrolled: false
  }),
  computed: {
    maxWidth() {
      return '1280px'
    }
  },
  created() {
    window.addEventListener('scroll', () => {
      this.isScrolled = !!window.pageYOffset
    })
  },
  methods: {
    onServices() {
      const element = this.$refs.services
      if (element) {
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        })
      }
    },
    onStart() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    onContact() {
      const element = this.$refs.contact
      if (element) {
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        })
      }
    },
    onAbout() {
      const element = this.$refs.about
      if (element) {
        window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>
